<div class="toolbar-container">
  <div class="col-md-11">
    <h2>Reorder {{data[0].pageName}}</h2>
  </div>
  <div class="col-md-1">
    <mat-icon class="pull-right" mat-dialog-close>close</mat-icon>
  </div>

</div>
<div class="row container">
  <div class="col-md-12">
    <form>
      <div class=" row item-border">
        <div class="col-md-12" style="padding: 2%;">
          <div class="table-container">
            <div id="header-container" class="row">
              <div class="col-md-4">
                <div class="search-container">
                  <span class="fa fa-search form-control-feedback"></span>
                  <input type="text" class="form-control" placeholder="Search" [(ngModel)]="searchVal">
                </div>
              </div>
            </div>


            <table>
              <thead>
                <th>Seq</th>
                <th *ngIf="data[0].pageName =='Content'">Content Name</th>
                <th *ngIf="data[0].pageName =='Question'">Question</th>
                <th>New Seq</th>
              </thead>
              <tbody class="example-list" cdkDropList (cdkDropListDropped)="drop($event)">
                <tr class="data-row-container" *ngFor="let content of data" cdkDrag>
                  <td *ngIf="data[0].pageName =='Content'">{{content.contentSeq}}</td>
                  <td *ngIf="data[0].pageName =='Question'">{{content.seq}}</td>
                  <td *ngIf="data[0].pageName =='Content'">{{content.contentName}}</td>
                  <td *ngIf="data[0].pageName =='Question'">{{content.question}}</td>
                  <td>{{content.newSeq}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <br>
      <div class="row">
        <div class="col-md-12 text-center">
          <button style="margin-right: 1%;" mat-raised-button color="primary" (click)="okForReorder()">Reorder</button>
          <button mat-raised-button (click)="closeDialog()">Cancel</button>
        </div>
      </div>
      <br>
    </form>
  </div>
</div>
